export {
  default as TelephoneInput,
  type TelephoneInputProps,
} from './TelephoneInput';
